import * as React from 'react';
import { IgcGridToolbarHidingComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import type { IgcGridToolbarHidingComponentEventMap } from 'igniteui-webcomponents-grids/grids/index.js';
import { type EventName, createComponent } from '../react-props.js';

/**
 * Provides a pre-configured column hiding component for the grid.
 * @fires opening - Emits an event before the toggle container is opened.
 * @fires opened - Emits an event after the toggle container is opened.
 * @fires closing - Emits an event before the toggle container is closed.
 * @fires closed - Emits an event after the toggle container is closed.
 * @fires columnToggle - Emits when after a column's checked state is changed
 */
export const IgrGridToolbarHiding = createComponent({
  tagName: 'igc-grid-toolbar-hiding',
  displayName: 'IgrGridToolbarHiding',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
  events: {
    onOpening: 'opening' as EventName<
      IgcGridToolbarHidingComponentEventMap['opening']
    >,
    onOpened: 'opened' as EventName<
      IgcGridToolbarHidingComponentEventMap['opened']
    >,
    onClosing: 'closing' as EventName<
      IgcGridToolbarHidingComponentEventMap['closing']
    >,
    onClosed: 'closed' as EventName<
      IgcGridToolbarHidingComponentEventMap['closed']
    >,
    onColumnToggle: 'columnToggle' as EventName<
      IgcGridToolbarHidingComponentEventMap['columnToggle']
    >,
  },
});

export type IgrGridToolbarHiding = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrGridToolbarHidingModule = Component;
